export default {
  ADD_REQUIRED_INFORMATION (state, data) {
    state.requiredInformation = data
  },
  ADD_NEW_REQUIRED_INFORMATION (state, information) {
    state.requiredInformation.push(information)
  },
  DELETE_REQUIRED_INFORMATION (state, id) {
    state.requiredInformation = state.requiredInformation.filter(d => d.id !== id)
  },
  UPDATE_REQUIRED_INFORMATION (state, info) {
    Object.assign(state.requiredInformation.find(d => d.id === info.id), info)
  },
  ADD_REQUIRED_INFORMATION_FILE (state, file) {
    const data = state.requiredInformation.find(i => i.id === file['required_information_id'])
    data.requiredInformationFiles.push(file)
  },
  UPDATE_REQUIRED_INFORMATION_FILE (state, file) {
    const data = state.requiredInformation.find(i => i.id === file['required_information_id'])
    Object.assign(data.requiredInformationFiles.find(f => f.id === file.id), file)
  },
  ADD_REQUIRED_INFORMATION_BOOKKEERPING (state, bookkeeping) {
    const info = state.requiredInformation.find(i => i.id === bookkeeping['required_information_id'])
    info.requiredInformationBookkeepings.push(bookkeeping)
  },
  DELETE_REQUIRED_INFORMATION_FILE (state, file) {
    const info = state.requiredInformation.find(i => i.id === file['required_information_id'])
    info.requiredInformationFiles = info.requiredInformationFiles.filter(f => f.id !== file.id)
  },
  CHANGE_REQUIRED_INFORMATION_FILE (state, data) {
    const info = state.requiredInformation.find(i => i.id === data['required_information_id'])
    info.requiredInformationFiles.find(s => s.id === data.id).file = data.file
  },
  ADD_REQUIRED_INFORMATION_ROW (state, row) {
    const info = state.requiredInformation.find(i => i.id === row['required_information_id'])
    info.requiredInformationRows.push(row)
  },
  DELETE_REQUIRED_INFORMATION_ROW (state, row) {
    const info = state.requiredInformation.find(i => i.id === row['required_information_id'])
    info.requiredInformationRows = info.requiredInformationRows.filter(f => f.id !== row.id)
  },
  DELETE_REQUIRED_INFORMATION_BOOKKEEPING (state, row) {
    const info = state.requiredInformation.find(i => i.id === row['required_information_id'])
    info.requiredInformationBookkeepings = info.requiredInformationBookkeepings.filter(f => f.id !== row.id)
  },
  CHANGE_REQUIRED_BOOKKEEPING_FILE (state, data) {
    const info = state.requiredInformation.find(i => i.id === data['required_information_id'])
    const bookkeeping = info.requiredInformationBookkeepings.find(b => b.id === data.id)
    bookkeeping.file = data.file
  },
  UPDATE_REQUIRED_INFORMATION_ROW (state, data) {
    const information = state.requiredInformation.find(i => i.id === data['required_information_id'])
    Object.assign(information.requiredInformationRows.find(i => i.id === data.id), data)
  },
  UPDATE_REQUIRED_INFORMATION_BOOKKEEPEING (state, data) {
    const information = state.requiredInformation.find(i => i.id === data['required_information_id'])
    Object.assign(information.requiredInformationBookkeepings.find(i => i.id === data.id), data)
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations/requiredInformation.js